import React from "react";
import OkDialogLayout from "~/components/DialogLayout/OkDialogLayout";
interface RequestInsightsTrialDialogProps {
    dialogTitle?: string;
    onRequestTrial: (() => Promise<boolean>) | (() => Promise<void>);
    errors?: Error[];
    busy?: boolean;
}
function RequestFreeTrialDialog({ dialogTitle, onRequestTrial, errors, busy }: RequestInsightsTrialDialogProps) {
    const title = dialogTitle ?? "Request Free Trial";
    return (<OkDialogLayout errors={errors} title={title} okButtonLabel="Send Request" onOkClick={onRequestTrial} okButtonImportance="loud" busy={busy}>
            <p>After you submit the request, our Customer Success Team will email you with the trial details.</p>
        </OkDialogLayout>);
}
export default RequestFreeTrialDialog;
